import { Component, OnInit, ViewChild } from '@angular/core';
import { Endorsement, EndorsementMethod } from '../_models/endorsement';
import { NgForm } from '@angular/forms';
import { EndorsementService } from '../_services/endorsement.service';
import { EndorsementSteps, LOBType, EndorsementType, DocumentFileType, ClassAction, LocationType } from 'src/app/_common/_enum/module.enum';

@Component({
  selector: 'app-endorsement-review',
  templateUrl: './endorsement-review.component.html',
  styleUrls: ['./endorsement-review.component.scss']
})
export class EndorsementReviewComponent implements OnInit {

  //private selectedAccount;

  private lobTypeEnum = LOBType; // Using it in HTML
  private endorsementTypeEnum = EndorsementType; // Using it in HTML
  private documentFileTypeEnum = DocumentFileType; // Using it in HTML
  private classActionEnum = ClassAction; // Using it in HTML
  private locationTypeEnum = LocationType; // Using it in HTML

  private endorsementReview: Endorsement;
  private endorsementMethods: EndorsementMethod;
  private supportingDocuments = [];
  private isSubmitted: boolean = false;

  private allEndorsementTypes:any = [];
  private selectedEndorsementTypes = [];

  private showBackdatedBanner: boolean = false;

  private profile;
  
  @ViewChild("reviewForm", {static: false}) reviewForm: NgForm;
  constructor(private endorsementService:EndorsementService) { }

  ngOnInit() {
    this.endorsementReview = this.getEndorsement();
    this.endorsementMethods = new EndorsementMethod();
    this.supportingDocuments = this.endorsementService.getSupportingDocuments();
    //this.selectedAccount = this.endorsementService.getAccountData();
    this.profile = this.endorsementService.getLoggedInProfile();

    let today = new Date();
    today.setHours(0,0,0,0);
    this.showBackdatedBanner = Date.parse(this.endorsementReview.effectiveDate)-Date.parse(today.toLocaleDateString())<-1;

    this.allEndorsementTypes = this.endorsementMethods.getEndorsementTypes(this.endorsementReview);

    let filteredArray = this.allEndorsementTypes.filter((_endorsementTypes) => 
      _endorsementTypes.some((_endorsementType) => _endorsementType.isSelected))
      .map(_endorsementTypes => {
        this.selectedEndorsementTypes.push(_endorsementTypes.filter(_endorsementType => _endorsementType.isSelected));

      }); 
    console.log(this.selectedEndorsementTypes);
  }
  
  getEndorsement(){
    return this.endorsementService.endorsement;
  }

  capitalize(_string, otherCharsLowerCase=false){
    if(otherCharsLowerCase){
      return _string.charAt(0).toUpperCase() + _string.slice(1).toLowerCase();
    }else{
      return _string.charAt(0).toUpperCase() + _string.slice(1);
    }
  }

  editRequest(_endorsementType){
    if(_endorsementType == ''){
      this.endorsementReview.selectedStep = EndorsementSteps.BasicInfo;
      this.endorsementService.selectedStep = EndorsementSteps.BasicInfo;
    }else{
      this.endorsementReview.selectedStep = EndorsementSteps.UnderwritingNeeds;
      this.endorsementService.selectedStep = EndorsementSteps.UnderwritingNeeds;
    }

    this.endorsementService.endorsement = this.endorsementReview;

    window.scrollTo(0, 0);
  }

  getSupportingDocuments(_docFileType){
    let docFiles = this.endorsementService.getSupportingDocuments().filter(_docFile=>{return _docFile.docFileType == _docFileType});

    return docFiles;
  }
  
  hasLOBTypeForm(_type){
    return this.endorsementReview.EndorsementForm[_type.toUpperCase()] != undefined;
  }
  hasEndorsementTypeForm(_type, _endorsementType){
    return this.endorsementReview.EndorsementForm[_type.toUpperCase()] != undefined && this.endorsementReview.EndorsementForm[_type.toUpperCase()][_endorsementType.toUpperCase()];
  }

  onContinue():boolean{    
    this.isSubmitted = true;
    return (this.reviewForm.valid);
  }
}
